(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('ProductTypeByCategory', ProductTypeByCategory);

    ProductTypeByCategory.$inject = ['$resource'];

    function ProductTypeByCategory ($resource) {
        var resourceUrl =  '/api/product-categories/:id/product-types';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
